import { AxiosResponse } from 'axios';
import { NewArrivalNotificationListResponse, NewArrivalNotificationRequest } from 'types/entity';
import { headerAccessPoint, http } from './settings';

export const fetchNewArrivalNotifications = (
  selectedProjectId: string,
  offset: number,
  readContentType: 'READ' | 'UNREAD' | 'ALL',
): Promise<NewArrivalNotificationListResponse> => http
  .get(
    `/projects/${selectedProjectId}/new-arrival-notification/search`,
    {
      headers: headerAccessPoint,
      params: {
        offset,
        read_content_type: readContentType,
      },
    },
  )
  .then((value:AxiosResponse<NewArrivalNotificationListResponse>) => value.data);

export const markAsReadNewArrivalNotifications = (projectId: string, newArrivalNotificationRequest: NewArrivalNotificationRequest) => http
  .put(
    `/projects/${projectId}/new-arrival-notification/markAsRead`,
    newArrivalNotificationRequest,
  );
